import React, { FunctionComponent, useContext, useEffect } from 'react';
import styles from './DirectoryCard.module.scss';
import { DirectoryListType } from '../../directory-list/DirectoryList';
import { AppContext } from '../../../context/AppContext';

export interface IDirectoryCardProps {
  title: string;
  listType: DirectoryListType;
  currentListType: DirectoryListType;
  children: React.ReactNode;
  onClick?: () => void; // optional external click handler
}

const DirectoryCard: FunctionComponent<IDirectoryCardProps> = ({
  title,
  currentListType,
  listType,
  children,
  onClick
}) => {
  const appContext = useContext(AppContext);

  // Only update AppContext if there is no external onClick
  const handleClick = () => {
    if (onClick) {
      onClick(); // External link or custom action
      return;    // Skip AppContext updates completely
    }

    appContext.updateListType(listType);
    appContext.updateSelected(true);
  };

  const isActive =
    onClick
      ? false // Dentist tile: never active
      : appContext.isDirectorySelected && currentListType === listType;

  return (
    <button
      className={`${styles.directoryCard}${isActive ? ' ' + styles.isActive : ''}`}
      onClick={handleClick}
    >
      <div>{children}</div>
      <div className={styles.cardText}>{title}</div>
    </button>
  );
};

export default DirectoryCard;
